import type { JSX } from 'react'

import { ButtonCorners, ButtonFonts } from 'atoms/Button/Button.h'
import { PrimaryButton } from 'atoms/Button/Templates'
import { TextBox } from 'atoms/TextBox'
import { TextAligning, TextBoxTypes } from 'atoms/TextBox/TextBox.h'
import { CastOptionIsNotAllowedSC } from './CastOptionIsNotAllowed.styled'
import { OverlaySC } from './UpgradeCurrentPackage.styled'

export interface ICastOptionIsNotAllowedProps {
  title: string
  buttonTitle: string
  onOk: () => void
  smallPlayer?: boolean
}

export const CastOptionIsNotAllowed = ({
  title,
  buttonTitle,
  onOk,
  smallPlayer,
}: ICastOptionIsNotAllowedProps): JSX.Element => {
  const font = smallPlayer ? TextBoxTypes.FontLgBold : TextBoxTypes.FontXlBold

  const handleOk = (_event: React.MouseEvent<Element, MouseEvent>) => {
    onOk()
  }

  return (
    <OverlaySC smallPlayer={smallPlayer}>
      <CastOptionIsNotAllowedSC smallPlayer={smallPlayer}>
        <TextBox
          font={font}
          maxLines={2}
          title={title}
          alignment={TextAligning.Center}
        />

        <PrimaryButton
          title={buttonTitle}
          onClick={handleOk}
          corners={ButtonCorners.CORNERS_10}
          font={ButtonFonts.FontSmBold}
        />
      </CastOptionIsNotAllowedSC>
    </OverlaySC>
  )
}
